import { render, staticRenderFns } from "./autocomplete-section.vue?vue&type=template&id=4a9d652d"
import script from "./autocomplete-section.vue?vue&type=script&lang=ts"
export * from "./autocomplete-section.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports